import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const scheduledLogsList = createAsyncThunk('scheduledLogsList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `maintenance_logs`,
            params: {
                'maintenance_id': data?.maintenance_id,
                'log_type': data?.log_type,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const scheduledLogsListSlice = createSlice({
    name: 'scheduledLogsList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(scheduledLogsList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(scheduledLogsList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default scheduledLogsListSlice.reducer;